import { Outlet, createFileRoute, useParams } from '@tanstack/react-router';

import { VStack } from '@/components/Layout';

import { MyCertificationProfileHeader } from '../../-components/CertificationProfileHeader';
import { CertificationKind } from '../../-constants';
import { useGetMySpecialtyCertificationHeader } from '../../-queries';

export const Route = createFileRoute(
  '/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = useParams({
    from: '/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout',
  });
  const { data } = useGetMySpecialtyCertificationHeader(id);

  return (
    <VStack className="gap-0">
      <MyCertificationProfileHeader
        certificationId={id}
        certificationName={data.personSpecialtyCertification.certificationName}
        certificationNumber={
          data.personSpecialtyCertification.certificationNumber
        }
        certificationStatus={
          data.personSpecialtyCertification.certificationStatus
        }
        certificationKind={CertificationKind.SPECIALTY}
        certificationHolder={{
          name: data.personSpecialtyCertification.certificationHolder.name,
          avatarUrl:
            data.personSpecialtyCertification.certificationHolder.avatarUrl ??
            undefined,
        }}
      />
      <Outlet />
    </VStack>
  );
}
